import { ComponentDocs } from "components/docs";
import { ComponentExample } from "components/examples";

const FormObject = () => (
  <ComponentDocs
    name="<Form.Object/>"
    entry="ObjectField"
    propsEntry="ObjectFieldProps"
    namespace="FormCollections"
  >
    <ComponentExample
      name="Object field"
      import={import("examples/Forms/FormObject/ObjectFieldExample")}
      rawImport={import("examples/Forms/FormObject/ObjectFieldExample?raw")}
    />
    <ComponentExample
      name="Propagate updates"
      description="By default Form.Object will only re-render if one of its fields change. To re-render when external variables change pass them as a dependency array to the propagateUpdates prop."
      import={import("examples/Forms/FormObject/PropagateObjectUpdatesExample")}
      rawImport={import(
        "examples/Forms/FormObject/PropagateObjectUpdatesExample?raw"
      )}
    />
  </ComponentDocs>
);

export default FormObject;
